import View from './view';


/**
 * poppet.Form
 * A description.
 * @version 0.1
 */

const Form = View.extend({

	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	tagName   : 'form',
	behaviors : {
		ViewAnimator: {},
		FormEnabler: {},
	},


	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------

	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	/**
	 * Changes the stored options object of the layout.
	 * @overwrite
	 * @void
	 */
	settings: function (options) {
		View.prototype.settings.call(this, options);

		if (!_.isUndefined(this.options.initValidation)) {
			this.noInitValidation = !this.options.initValidation;
		}
	},

});

export default Form;
